import { createFeatureSelector, createSelector } from '@ngrx/store';
import { complianceFeatureKey } from 'src/app/compliance/store/selectors';
import { ComplianceState } from 'src/app/compliance/store/state/compliance.state';

export const complianceFeature = createFeatureSelector<ComplianceState>(complianceFeatureKey);

export const selectFilter = createSelector(complianceFeature, (state) => state.complianceRequests.filter);
export const selectLabTicketRequestsFilter = createSelector(
    complianceFeature,
    (state) => state.complianceRequests?.filterLabTicketRequests
);
export const selectComplianceTicketRequestsFilter = createSelector(
    complianceFeature,
    (state) => state.complianceRequests?.filterComplianceTicketRequests
);

export const selectComplianceRequests = createSelector(
    complianceFeature,
    (state) => state.complianceRequests.complianceRequests
);

export const selectComplianceTicketRequests = createSelector(
    complianceFeature,
    (state) => state.complianceRequests.complianceTicketRequests
);

export const selectLabTicketRequests = createSelector(
    complianceFeature,
    (state) => state.complianceRequests.labTicketRequests
);

export const selectStatusUpdate = createSelector(complianceFeature, (state) => state?.complianceRequests?.statusUpdate);
export const selectStatusUpdatedRequestIds = createSelector(
    complianceFeature,
    (state) => state?.complianceRequests?.updatedRequestIds
);

export const getReloadGridDelay = createSelector(
    complianceFeature,
    (state) => state?.complianceRequests?.reloadWithDelay
);

export const selectUnmappedName = createSelector(complianceFeature, (state) => state?.complianceRequests?.unmappedName);

export const selectAssigneesFilter = createSelector(
    complianceFeature,
    (state) => state?.complianceRequests?.assigneesFilter
);

export const getDsMapped = createSelector(complianceFeature, (state) => state?.complianceRequests?.dsMapped);
